export default __webpack_public_path__ + "static/media/699.c7ac64cd.jpg";